import { Injectable } from '@angular/core';
import { UserProfileData } from '@finxone-platform/shared/sys-config-types';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Observable, catchError, tap } from 'rxjs';
import {
  AddProgressBarWorkflowStack,
  RemoveProgressBarWorkflowStack,
} from '../actions/progress-bar-workflow.action';

import { GetPersonalProfile, UpdatePersonalProfile } from '../actions/personal-profile.action';
import { ApiService } from '../services/api-service/api.service';

export interface PersonalProfileStateModel {
  detail: UserProfileData;
}

@State<PersonalProfileStateModel>({
  name: 'personalProfile',
  defaults: {
    detail: {} as UserProfileData,
  },
})
@Injectable()
export class PersonalProfileState {
  constructor(private apiService: ApiService) {}

  @Selector()
  static getPersonalProfileDetail(state: PersonalProfileStateModel) {
    return state.detail;
  }

  @Action(GetPersonalProfile)
  fetchPersonalProfile(ctx: StateContext<PersonalProfileStateModel>) {
    ctx.dispatch(new AddProgressBarWorkflowStack({ uniqueId: 'GetPersonalProfile' }));
    return this.apiService.getCall<UserProfileData>(`user/get-user-profile`).pipe(
      tap((response: UserProfileData) => {
        ctx.patchState({
          detail: response,
        });

        ctx.dispatch(
          new RemoveProgressBarWorkflowStack({
            uniqueId: 'GetPersonalProfile',
          }),
        );
      }),
      catchError<unknown, Observable<boolean>>((_err) => {
        ctx.dispatch(
          new RemoveProgressBarWorkflowStack({
            uniqueId: 'GetPersonalProfile',
          }),
        );
        throw _err;
      }),
    );
  }

  @Action(UpdatePersonalProfile)
  updatePersonalProfile(ctx: StateContext<PersonalProfileStateModel>, action: UpdatePersonalProfile) {
    ctx.dispatch(new AddProgressBarWorkflowStack({ uniqueId: 'UpdatePersonalProfile' }));
    return this.apiService.postCall<UserProfileData>(`user/update-user-profile`, action.payload).pipe(
      tap(() => {
        ctx.dispatch(
          new RemoveProgressBarWorkflowStack({
            uniqueId: 'UpdatePersonalProfile',
          }),
        );
      }),
      catchError<unknown, Observable<boolean>>((_err) => {
        ctx.dispatch(
          new RemoveProgressBarWorkflowStack({
            uniqueId: 'UpdatePersonalProfile',
          }),
        );
        throw _err;
      }),
    );
  }
}
